exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".itinerary-grid[data-v-462febd8]{display:flex;line-height:48px;padding-left:24px;padding-right:24px;border-bottom:1px solid var(--black-light-2);border-right:1px solid var(--black-light-2);border-left:1px solid var(--black-light-2)}.itinerary-grid[data-v-462febd8]:nth-child(odd){background-color:var(--black-light-1)}.itinerary-grid[data-v-462febd8]:last-child{border-bottom:1px solid var(--black-light-2);border-bottom-left-radius:.25rem;border-bottom-right-radius:.25rem}.itinerary-grid[data-v-462febd8]:first-child{border-top:1px solid var(--black-light-2);border-top-left-radius:.25rem;border-top-right-radius:.25rem}", ""]);

// exports
